// extracted by mini-css-extract-plugin
export default {"fix_bottom":"index_fix_bottom_U1Bjs","fix_follow":"index_fix_follow_O-JWo"};